import { RenewalData } from "../../../data";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Back from "../../../components/shared/back";
import Button from "../../../components/shared/custom-btn";
import RenewalDetails from "./renewal-details";
import Media from "./tabs-components/media";
import Notes from "./tabs-components/notes";
import Expenses from "./tabs-components/expenses";
import Help from './help';
import { usePageHelp } from '../../../components/context/help-context';

const TABS = [
    { name: "Expenses", component: <Expenses /> },
    { name: "Media", component: <Media /> },
    { name: "Notes", component: <Notes /> },
];

const RenewalViews = () => {
    usePageHelp(Help);
    const { renewalId } = useParams();
    const [activeTab, setActiveTab] = useState("Expenses");

    const renewal = RenewalData.find((v) => v.renewalId === renewalId);
    const activeTabContent = TABS.find(tab => tab.name === activeTab)?.component || <div className="p-4">No Content Available</div>;

    return (
        <div className="p-4 bg-white min-h-screen relative">
            <Back />

            {/* Header */}
            <div className="bg-white flex flex-col md:flex-row items-start md:items-center w-full justify-between gap-6 mt-4">
                <RenewalDetails
                    renewal={renewal}
                    renewalId={renewalId}
                />
                {activeTab !== "Overview" && (
                    <Button
                        label={`Add ${activeTab}`}
                        className="text-white px-4 !py-1 rounded-lg bg-btnBg"
                    />
                )}
            </div>

            {/* Tabs */}
            <div className="mt-6 border-b border-gray-200">
                <nav className="flex overflow-x-auto gap-4 no-scrollbar">
                    {TABS.map((tab) => (
                        <button
                            key={tab.name}
                            onClick={() => setActiveTab(tab.name)}
                            className={`flex items-center justify-between px-1 text-left py-2 text-sm  border-gray-200 
                                ${activeTab === tab.name
                                    ? "border-b-2 border-purple-600 text-purple-600 font-medium"
                                    : "text-gray-600 hover:text-gray-900"
                                }`}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Tab Content */}
            <div className="mt-3">
                <div className="px-2 bg-white">
                    {activeTabContent}
                </div>
            </div>
        </div>
    );
};

export default RenewalViews;
